"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Dependency_1 = require("./Dependency");
const NodeDependency_1 = require("./NodeDependency");
const ExecutableDependency_1 = require("./ExecutableDependency");
class DependencyFactory {
    constructor(definition, options) {
        this.definition = definition;
        this.options = options;
    }
    dependency() {
        const { definition, options } = this;
        switch (definition.type) {
            case Dependency_1.DependencyType.Node:
                return new NodeDependency_1.NodeDependency(definition, options);
            case Dependency_1.DependencyType.Executable:
                return new ExecutableDependency_1.ExecutableDependency(definition, options);
            default:
                throw new Error(`Dependency type not found for: ${JSON.stringify(definition)}`);
        }
    }
}
exports.DependencyFactory = DependencyFactory;
//# sourceMappingURL=DependencyFactory.js.map